var _rect, _path, _rect2, _rect3, _rect4, _rect5, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinibar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 12,
    height: 13,
    rx: 1.5,
    stroke: "#001024"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22.5523 11 23 11.4477 23 12V20C23 20.5523 22.5523 21 22 21V11Z",
    fill: "#001024"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 14.5,
    width: 2,
    height: 6,
    rx: 0.5,
    stroke: "#001024"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 11.25,
    width: 0.5,
    height: 3.5,
    rx: 0.25,
    stroke: "#001024",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#001024"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 3,
    height: 1,
    transform: "rotate(90 18 18)",
    fill: "#001024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5C19.2761 14.5 19.5 14.7239 19.5 15L19.5 16.5C19.5 17.6046 18.6046 18.5 17.5 18.5C16.3954 18.5 15.5 17.6046 15.5 16.5L15.5 15C15.5 14.7239 15.7239 14.5 16 14.5L19 14.5Z",
    stroke: "#001024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinibar);
export default __webpack_public_path__ + "static/media/minibar.e9fad86ef7ea47e1e5d106d65e202990.svg";
export { ForwardRef as ReactComponent };